<template>
  <li class="mb-2 input-group input-option correct-order-option-item" :class="{'draggable-item': slideOption.id}">
    <div class="pr-3 horizontal layout center">
      {{ index + 1 }}
    </div>
    <div
      class="input-group-prepend handle-drag"
      :class="{'disabled': isDraggingDisabled}"
    >
      <div class="input-group-text horizontal layout center center-justified">
        <i class="fas fa-arrows-alt-v" />
      </div>
    </div>
    <aha-input
      v-model="title"
      :maxLength="50"
      :placeholder="getPlaceHolder(index)"
      @input="handleUpdateOptionTitle"
      class="flex-auto"
      :id="`correct-order-input-${index}`"
      :ref="`correct-order-input-${index}`"
      @keydown.tab="handleTabEvent"
      @keyup.enter="handleEnterEvent"
    />
    <div
      class="input-group-prepend pointer"
    >
      <div
        class="input-group-text horizontal layout center center-justified"
        :class="{'disabled': $store.state.slideActive.SlideOptions.length === 2 || isSyncing !== 2}"
        @click="isDeletable ? handleDeleteOption() : false"
      >
        <i class="far fa-trash-alt" />
      </div>
    </div>
  </li>
</template>

<script>
import _ from 'lodash'
import { mapState } from 'vuex'
import UndoRedoMixin from '@/mixins/undo-redo/UndoRedoMixin'
import EventBus from '@/eventBus'

export default {
  mixins: [UndoRedoMixin],
  props: {
    slideOption: {
      type: Object,
      default: () => {},
    },
    isDeletable: {
      type: Boolean,
      default: true,
    },
    handleSlideOptionChanged: {
      type: Function,
      required: true,
    },
    index: {
      type: Number,
      default: null,
    },
    isDraggingDisabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState({
      isSyncing: (state) => state.isSyncing,
    }),
  },
  data() {
    return {
      title: this.slideOption.title,
    }
  },
  mounted() {
    this.handleSlideOptionChangedDebounce = _.debounce(this.handleSlideOption, 300)
    EventBus.$on('update-title-option', () => {
      this.title = this.slideOption.title
    })
  },
  destroyed() {
    EventBus.$off(`update-title-option-${this.index}`)
  },
  methods: {
    getPlaceHolder(index) {
      return `${this.$i18nPresenter.t('Statement')} ${(index + 1)}`
    },
    handleSlideOption(slideOption, payload) {
      const key = (new Date()).getTime()
      this.lockHistory(key)
      this.handleSlideOptionChanged(slideOption, payload, key)
    },
    handleUpdateOptionTitle(data) {
      this.handleSlideOptionChangedDebounce(this.slideOption, {
        title: data,
      })
    },

    handleDeleteOption() {
      this.$emit('handleDeleteSlideOption', this.slideOption, this.index)
    },

    handleTabEvent(event) {
      if (!event || this.$store.state.slideActive.SlideOptions.length > 7) return
      if (this.index === this.$store.state.slideActive.SlideOptions.length - 1) {
        this.$emit('handleAddNewSlideOption')
      }
    },

    handleEnterEvent() {
      this.$emit('handleAddNewSlideOption')
    },
  },
}
</script>

<style lang="scss" scoped>
.correct-order-option-item{
  .disabled{
    pointer-events: none;
  }
}
</style>
